export enum PDxPOFileType {
    PDF = 1,
    EDI,
}